import { Skeleton, Box, Stack } from '@mui/material';
import { IconButton, Typography } from '@sweep-io/sweep-design';
import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons';

export const AiAssistantPageSkeleton = ({ goBackCb }: { goBackCb?: () => void }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="space-between">
        <Stack alignItems="center" direction="row" gap={1}>
          {goBackCb && (
            <IconButton variant="flat" size="tiny" onClick={goBackCb}>
              <ArrowLeft size="medium" />
            </IconButton>
          )}

          <Typography variant={goBackCb ? 'h3' : 'h2'}>Support AI</Typography>
        </Stack>
        <Skeleton variant="rectangular" width="201px" height="32px" sx={{ borderRadius: '8px' }} />
      </Box>
      <Skeleton variant="rectangular" width="100%" height="88px" sx={{ borderRadius: '8px' }} />
      <Box display="flex" justifyContent="space-between">
        <Skeleton variant="rectangular" width="270px" height="52px" sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rectangular" width="457px" height="52px" sx={{ borderRadius: '8px' }} />
      </Box>
      <Skeleton variant="rectangular" width="100%" height="52px" sx={{ borderRadius: '8px' }} />
    </Box>
  );
};
